import { render, staticRenderFns } from "./StockDetails.vue?vue&type=template&id=afb6f87c&scoped=true&"
import script from "./StockDetails.vue?vue&type=script&lang=js&"
export * from "./StockDetails.vue?vue&type=script&lang=js&"
import style0 from "./StockDetails.vue?vue&type=style&index=0&id=afb6f87c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afb6f87c",
  null
  
)

export default component.exports